// extracted by mini-css-extract-plugin
export default {"title":"WidgetTitle_title__Zu721"};